import { fetchURL, removePrefix } from './utils';
import i18n from '@/i18n';

import moment from 'moment';
// import { ActionLogger } from '../utils/log';

window.gRequestedThumbnails = new Set();

export function typeByExtension(extension) {
    let type = 'text';
    if (extension == 'jpg' || extension == 'jpeg' || extension == 'png' || extension == 'bmp' || extension == 'heic' || extension == 'heif') {
      type = 'image';
    }   
    else if (extension == 'mp3' || extension == 'wav' || extension == 'flac') {
      type = 'audio';
    }
    else if (extension == 'avi' || extension == 'mp4' || extension == 'mkv' || extension == 'mov' || extension == 'flv') {
      type = 'video';
    }
    else if (extension == 'pdf') {
      type = 'pdf';
    }
    else if (extension == 'stl') {
      type = 'stl';
    } 
    else if (extension == 'txt') {
      type = 'txt';
    } 
    else if (extension == 'zip') {
      type = 'zip';
    } 
    else if (extension == 'xls' || extension == 'xlsx') {
      type = 'xls';
    }
    else if (extension == 'doc' || extension == 'docx') {
      type = 'doc';
    }
    else if (extension == 'ppt' || extension == 'pptx') {
      type = 'ppt';
    }
    else if (extension == 'js' || extension == 'css' || extension == 'html' || extension == 'vue' || extension == 'java') {
      type = 'code';
    }
    return type;
}

export function nodeToObject(basepath, node) {
    let re = /(?:\.([^.]+))?$/;

    let obj = {};
    obj['handle'] = node.handle;
    obj['parentHandle'] = node.parentHandle;
    obj['isDir'] = (node.type != Module.NodeType.FILE.value);
    obj['mode'] = 2147484157;
    obj['size'] = node.size;
    obj['extension'] = re.exec(node.name)[1] || '';
    obj['extension'] = obj['extension'].toLowerCase();
    obj['crypto'] = node.crypto;
    obj['tag'] = node.tag;
    obj['status'] = node.status;

    let type = 'text';
    if (!obj['isDir']) {
      type = typeByExtension(obj['extension']);
    }
    else
    {
        if (node.type == Module.NodeType.DEVICE.value)
        {
            type = 'device';
        }
        else if (node.type == Module.NodeType.BACKUP.value)
        {
            type = 'backup';
            obj['lpath'] = node.lpath;
            obj['cron'] = node.cron;
            obj['stime'] = node.stime;
            obj['maxsnapshots'] = node.status >> 8;
            obj['status'] = node.status & 0xFF;
        } 
        else if (node.type == Module.NodeType.SNAPSHOT.value)
        {
            type = 'snapshot';
            obj['lpath'] = node.lpath;
            obj['cron'] = node.cron;
            obj['nfolders'] = node.nfolders;
            obj['nfiles'] = node.nfiles;
            obj['ftime'] = node.ftime;
            obj['stime'] = node.stime;
            obj['ntrerror'] = node.ntrerror;
        }
        else if (node.type == Module.NodeType.INBOX.value)
        {
            type = 'inbox';
            obj['message'] = node.message;
        }
        else if (node.type == Module.NodeType.RECORD.value)
        {
            type = 'record';
            obj['message'] = node.message;
        }
        else if (node.type == Module.NodeType.SHARE.value)
        {
            type = 'shared';
        }
        else // Module.NodeType.FOLDER.value
        {
            type = 'folder';
            obj['synced'] = node.synced;
        }
    }
    
    /*obj['name'] = node.name ? node.name : (basepath.startsWith('//bin') ? "Papelera" 
                                        : ((basepath.startsWith('//bak') ? "Copias de seguridad" 
                                        : ((basepath.startsWith('//reg') ? "Registro" 
                                        : ((basepath.startsWith('//sec') ? "Secret" 
                                        : ((basepath == "/") ? "Mis archivos" : "SIN_NOMBRE"))))))));*/
    
    obj['name'] = node.name ? node.name : (basepath.startsWith('//bin') ? 'Papelera' 
                                        : ((basepath.startsWith('//bak') ? 'Copias de seguridad' 
                                        : ((basepath.startsWith('//sec') ? 'Secret' 
                                        : ((basepath == '/') ? 'Mis archivos' : 'SIN_NOMBRE'))))));

    obj['path'] = node.name ? (basepath + obj['name']) : basepath;
    obj['modified'] = moment(node.ctime * 1000).format();
    obj['type'] = type;
    obj['nodeType'] = node.type;
    obj['contact'] = node.contact;

    if (node.type === Module.NodeType.SHARED_DRIVE_ROOT.value) {
      obj['virtualParentHandle'] = node.virtualParentHandle;
    }
    
    return obj;
} 

export async function getNextSnapshots () {
    let action = await ibb.getNextSnapshotsForAccount();
    if (action.error.type) {
      throw new Error('Error getting next snapshots: ' +  action.error.type);
    }

    let data = {};
    data['items'] = [];
    data['numFiles'] = action.nodeList.length;
    for (let i = 0; i < action.nodeList.length; i++) 
    {
        data['items'].push({});
        data['items'][i]['date'] = moment(action.numberList[i] * 1000).format();
        data['items'][i]['device'] = action.nodeList[i].device;
        data['items'][i]['name'] = action.nodeList[i].name;
        data['items'][i]['path'] = action.nodeList[i].lpath;
        data['items'][i]['type'] = i18n.t('info.snapshot');
        data['items'][i]['progress'] = 0;
        data['items'][i]['handle'] = action.nodeList[i].handle;
        data['items'][i]['status'] = i18n.t('info.pending');
        data['items'][i]['index'] = i;
        data['items'][i]['enabled'] = action.nodeList[i].enabled;
    }

    return data;
}

export async function getLastSnapshots () {
    let action = await ibb.getLastSnapshotsForAccount();
    if (action.error.type) {
      throw new Error('Error getting last snapshots: ' +  action.error.type);
    }

    let data = {};
    data['items'] = [];
    data['numFiles'] = action.nodeList.length;
    for (let i = 0; i < action.nodeList.length; i++) 
    {
        data['items'].push({});
        data['items'][i]['date'] = moment(action.nodeList[i].ctime * 1000).format();
        data['items'][i]['device'] = action.nodeList[i].device;
        data['items'][i]['name'] = action.nodeList[i].name;
        data['items'][i]['type'] = i18n.t('info.snapshot');
        data['items'][i]['path'] = action.nodeList[i].lpath;
        data['items'][i]['progress'] = 100;
        data['items'][i]['handle'] = action.nodeList[i].handle;
        data['items'][i]['status'] = i18n.t('info.correct');
        data['items'][i]['index'] = i;
    }

    return data;
}

export async function getUploads () {
    let action = await ibb.getTransfersByType(Module.TransferType.UPLOAD.value);
    if (action.error.type) {
      throw new Error('Error getting uploads: ' +  action.error.type);
    }

    let re = /(?:\.([^.]+))?$/;
    let data = {};
    data['isTransfers'] = 1;
    data['transferType'] = Module.TransferType.UPLOAD.value;
    data['items'] = [];
    data['numFiles'] = action.actionList.length;
    data['numDirs'] = 0;
    //store.commit('addUploadTransfers', action.actionList)
    for (let i = 0, j = 0; i < action.actionList.length; i++) 
    {
      if (action.actionList[i].customData === '') {
        data['items'].push({});
        data['items'][j]['transferType'] = action.actionList[i].type;
        data['items'][j]['name'] = action.actionList[i].text ? action.actionList[i].text : action.actionList[i].name;
        data['items'][j]['extension'] = re.exec(data['items'][j]['name'])[1] || '';
        data['items'][j]['extension'] = data['items'][j]['extension'].toLowerCase();
        data['items'][j]['type'] = (action.actionList[i].type == Module.ActionType.UPLOAD.value) ? typeByExtension(data['items'][j]['extension']) : 'folder';
        data['items'][j]['size'] = action.actionList[i].size;
        data['items'][j]['completed'] = action.actionList[i].completed;
        data['items'][j]['progress'] = action.actionList[i].size ? action.actionList[i].completed * 100 / action.actionList[i].size : 0;
        data['items'][j]['status'] = action.actionList[i].status;
        data['items'][j]['errorCode'] = action.actionList[i].errorCode;
        data['items'][j]['tag'] = action.actionList[i].tag;
        data['items'][j]['handle'] = action.actionList[i].handle;
        data['items'][j]['index'] = i;
        j++;
      }
    }

    return data;
}

export async function getDownloads () {
    let action = await ibb.getTransfersByType(Module.TransferType.DOWNLOAD.value);
    if (action.error.type) {
      throw new Error('Error getting downloads: ' +  action.error.type);
    }

    let re = /(?:\.([^.]+))?$/;
    let data = {};
    data['isTransfers'] = 1;
    data['transferType'] = Module.TransferType.DOWNLOAD.value;
    data['items'] = [];
    data['numFiles'] = action.actionList.length;
    data['numDirs'] = 0;
    //store.commit('addDownloadTransfers', action.actionList)
    for (let i = 0, j = 0; i < action.actionList.length; i++) 
    {
      if (action.actionList[i].customData === '') {
        data['items'].push({});
        data['items'][j]['transferType'] = action.actionList[i].type;
        data['items'][j]['name'] = action.actionList[i].text ? action.actionList[i].text : action.actionList[i].name;
        data['items'][j]['extension'] = re.exec(data['items'][j]['name'])[1] || '';
        data['items'][j]['extension'] = data['items'][j]['extension'].toLowerCase();
        data['items'][j]['type'] = (action.actionList[i].type == Module.ActionType.DOWNLOAD.value) ? typeByExtension(data['items'][j]['extension']) : 'folder';
        data['items'][j]['size'] = action.actionList[i].size;
        data['items'][j]['completed'] = action.actionList[i].completed;
        data['items'][j]['progress'] = action.actionList[i].size ? action.actionList[i].completed * 100 / action.actionList[i].size : 0;
        data['items'][j]['status'] = action.actionList[i].status;
        data['items'][j]['errorCode'] = action.actionList[i].errorCode;
        data['items'][j]['tag'] = action.actionList[i].tag;
        data['items'][j]['handle'] = action.actionList[i].handle;
        data['items'][j]['index'] = i;
        j++;
      }
    }

    return data;
}

export async function getCompletedTransfers () {
    let action = await ibb.getTransfersByStatus(Module.TransferType.LAST_TYPE.value, Module.TransferStatus.FINISHED.value);
    if (action.error.type) {
      throw new Error('Error getting completed: ' +  action.error.type);
    }

    let re = /(?:\.([^.]+))?$/;
    let data = {};
    data['isTransfers'] = 1;
    data['items'] = [];
    data['numFiles'] = action.actionList.length;
    data['numDirs'] = 0;
    for (let i = 0; i < action.actionList.length; i++) 
    {
        data['items'].push({});
        data['items'][i]['transferType'] = action.actionList[i].type;
        data['items'][i]['name'] = action.actionList[i].text ? action.actionList[i].text : action.actionList[i].name;
        data['items'][i]['extension'] = re.exec(data['items'][i]['name'])[1] || '';
        data['items'][i]['extension'] = data['items'][i]['extension'].toLowerCase();
        data['items'][i]['type'] = (action.actionList[i].type == Module.ActionType.DOWNLOAD.value || action.actionList[i].type == Module.ActionType.UPLOAD.value) 
                                   ? typeByExtension(data['items'][i]['extension']) : 'folder';
        data['items'][i]['size'] = action.actionList[i].size;
        data['items'][i]['completed'] = action.actionList[i].completed;
        data['items'][i]['progress'] = action.actionList[i].size ? action.actionList[i].completed * 100 / action.actionList[i].size : 0;
        data['items'][i]['status'] = action.actionList[i].status;
        data['items'][i]['errorCode'] = action.actionList[i].errorCode;
        data['items'][i]['tag'] = action.actionList[i].tag;
        data['items'][i]['index'] = i;
    }

    return data;
}

export async function getUserInfo () {
  let action = await ibb.getUserInfo();
  if (action.error.type) {
    throw new Error('Error getting user info: ' + action.error.type);
  }

  return action;
}

export async function getAccountCoupons() {
  let action = await ibb.getAccountCoupons();
  if (action.error.type) {
    throw new Error('Error getting account coupons: ' + action.error.type);
  }

  return action;
}

export async function getReferralsInfo() {
  let action = await ibb.getReferralsInfo();
  if (action.error.type) {
    throw new Error('Error getting referrals info: ' + action.error.type);
  }

  return action;
}

export async function getBalancesInfo() {
  let action = await ibb.getBalancesInfo();
  if (action.error.type) {
    throw new Error('Error getting balances info: ' + action.error.type);
  }

  return action;
}

export async function getAccountInfo () {
    let action = await ibb.getAccountInfo();
    if (action.error.type) {
      throw new Error('Error getting account info: ' + action.error.type);
    }

    return action;
}

export async function getSubscriptionOptions () {
  let action = await ibb.getSubscriptionOptions();
  if (action.error.type) {
    throw new Error('Error getting subscription options: ' + action.error.type);
  }

  return action.subscriptionInfoList.filter(({id}) => id != 99 && id <= 107);
}

export async function getSubscriptionOptionsWithFeatures (features) {
  let action = await ibb.getSubscriptionOptionsWithFeatures(features);
  if (action.error.type) {
    throw new Error('Error getting subscription options with features: ' + action.error.type);
  }

  return action.subscriptionInfoList.filter(({id}) => id != 99 && id <= 107);
}

export async function setSubscription (id) {
  let action = await ibb.setSubscription(id);
  if (action.error.type) {
    throw new Error('Error setting subscription: ' + action.error.type);
  }
}

export async function getParent (handle, ibbInstance = ibb) {
    let action = await ibbInstance.getNodeById(handle);
    if (action.error.type) {
      throw new Error('Error getting node path: ' + action.error.type);
    }

    return nodeToObject('/', action.node);
}

export async function fetchId (handle, sortOrder = Module.SortOrderType.SORT_ORDER_DEFAULT.value, ibbInstance = ibb) {
  let action = await ibbInstance.getNodePath(handle);
  if (action.error.type) {
    throw new Error('Error getting node path: ' + action.error.type);
  }

  let path = action.text;
  action = await ibbInstance.getNodeById(handle);
  if (action.error.type) {
    throw new Error('Error getting node by id: ' + action.error.type);
  }

  return await fetchAction(action, path, sortOrder, ibbInstance);
}

export async function fetch (url, sortOrder = Module.SortOrderType.SORT_ORDER_DEFAULT.value, ibbInstance = ibb) {
    url = removePrefix(url);
    let path = decodeURIComponent(url);
    let action = await ibbInstance.getNodeByPath(path);
    if (action.error.type) {
      throw new Error('Error getting node by path: ' + action.error.type);
    }
    return await fetchAction(action, path, sortOrder, ibbInstance);
}

async function fetchAction (action, path, sortOrder = -Module.SortOrderType.SORT_ORDER_CREATION_TIME.value, ibbInstance = ibb) {
  console.log('fetch: ' + path);

  let data;
  data = nodeToObject(path, action.node);
  data['path'] = path;

  if (action.node.type != Module.NodeType.FILE.value) {
    data['sorting'] = {};
    data['sorting']['by'] = 'name';
    data['sorting']['asc'] = false;

    const [action1, action2] = await Promise.all([
      ibbInstance.getSortedChildFolders(action.node.handle, sortOrder),
      ibbInstance.getSortedChildFiles(action.node.handle, Module.SortOrderType.SORT_ORDER_CREATION_TIME.value)
    ]);

    
    
    data['items'] = [];
    data['numDirs'] = 0;
    data['numFiles'] = 0;
    data['nodeType'] = action.node.type;
    data['message'] = action.node.message;

    const m = new Map();
    for (const node of action2.nodeList) {
      if (m.get(node.name)) {
        const files = m.get(node.name);
        files.push(node);
        const totalSize = files.reduce((a, f) => a + f.size, 0);
        if (totalSize >= 1073741824) {
          const firstVersion = files.shift();
          await ibbInstance.deleteNode(firstVersion.handle);
        }
      } else {
        m.set(node.name, [node]);
      }
    }
    
    const action3 = await ibbInstance.getSortedChildFiles(action.node.handle, sortOrder);
    
    const visibleNodes = action3.nodeList.reduce((m, node) => {
      const previousNode = m.get(node.name);
      if (!previousNode || node.ctime > previousNode.ctime) {
        m.set(node.name, node);
      }
      return m;
    }, new Map()).values();
    
    let children = action1.nodeList.concat(...visibleNodes);

    // Filtro: carpetas internas de Iberbox (historial de versiones, etc.)
    // quedan fuera del listado de usuario. Todas empiezan con ".iberbox-".
    children = children.filter(n => !(n && n.name && typeof n.name === 'string' && n.name.indexOf('.iberbox-') === 0));

    for (let i = 0; i < children.length; i++) {
      data['items'].push(nodeToObject(path, children[i]));
      data['items'][i]['isDir'] ? data['numDirs']++ : data['numFiles']++;
    }
  }
  else {
    let node = action.node;
    let fileid = node.handle + '/' + node.name;
    if (!Module.isFileAvailable(fileid)) {
      // action = await ibbInstance.downloadWithCustomData(node.handle, fileid, 'preview');
      // if (action.error.type) {
      //   throw new Error('Error downloading node: ' + action.error.type);
      // } 
    }

    if (data['type'] == 'text' || data['type'] == 'txt') {
      // Intento de decodificación "best effort": si el archivo ya está en
      // la caché local del Module (recién subido, abierto hace un momento),
      // rellenamos `data.content` para que el Editor lo pinte instantáneo.
      // Si la caché no lo tiene o hay bytes binarios que no son UTF-8 válido,
      // NO degradamos el type a "blob" — el nuevo Editor.vue se encarga de
      // descargar los bytes él mismo (vía api.getFileBytes) en mounted().
      // Mantener type='txt' permite que el getter isEditor se active y se
      // monte el Editor en lugar de caer a Preview.
      try {
        if (Module.isFileAvailable && Module.isFileAvailable(fileid)) {
          const fileData = Module.getFileData(fileid);
          const decoder = new TextDecoder('utf-8', { fatal: true });
          data['content'] = decoder.decode(fileData);
        }
      } catch (_) {
        // Silencio: el Editor cargará los bytes por su cuenta.
      }
    }
  }

  //const res = await fetchURL(`/api/resources${url}`, {})
  //if (res.status === 200) {
    //let data = await res.json()

    if (path.startsWith('//')) {
      if (path.startsWith('//bin')) {
        data.url = '/bin#' + path.substring(5);
      }
      else if (path.startsWith('//bak')) {
        data.url = '/bak#' + path.substring(5);
      }
      else if (path.startsWith('//sec')) {
        data.url = '/sec#' + path.substring(5);
      }
      else if (path.startsWith('//shdd')) {
        data.url = '/shdd#' + path.substring(6);
      }
      else
      {
        data.url = path.slice(1);
      }
    }
    else {
          data.url = `/cloud#${path}`;
    }

    if (data.isDir) {
      if (!data.url.endsWith('/')) data.url += '/';
      data.items = data.items.map((item, index) => {
        item.index = index;
        item.url = `${data.url}${encodeURIComponent(item.name)}`;

        if (item.isDir) {
          item.url += '/';
        }

        return item;
      });
    }

    return data;
  //} else {
  //  throw new Error(res.status)
  //}
}

async function resourceAction (url, method, content) {
  console.log('resourceAction: ' + url + ' method: ' + method + ' content: ' + typeof(content));

  url = removePrefix(url);

  let opts = { method };

  if (content) {
    opts.body = content;
  }

  const res = await fetchURL(`/api/resources${url}`, opts);

  if (res.status !== 200) {
    throw new Error(res.responseText);
  } else {
    return res;
  }
}

export async function removeId (handle, ibbInstance = ibb) {
  let action = await ibbInstance.deleteNode(handle);
  if (action.error.type) {
    throw new Error('Error deleting node: ' + action.error.type);
  }

  return '200 OK';
}

export async function remove (url) {
  
  url = removePrefix(url);
  let path = decodeURIComponent(url);
  let action = await ibb.getNodeByPath(path);
  if (action.error.type) {
    throw new Error('Error getting node by path: ' + action.error.type);
  }

  if (url.startsWith('//bin')) {
    action = await ibb.deleteNode(action.node.handle);
    if (action.error.type) {
      throw new Error('Error deleting node: ' + action.error.type);
    }  
  }
  else {
    let h = action.node.handle;
    action = await ibb.getNodeByPath('//bin/');
    if (action.error.type) {
      throw new Error('Error getting the recycle bin: ' + action.error.type);
    }

    action = await ibb.moveNode(h, action.node.handle);
    if (action.error.type) {
      throw new Error('Error moving node to the recycle bin: ' + action.error.type);
    }  
  }

  return '200 OK';
}

export async function putId (handle, content = '', ibbInstance = ibb, onNewHandle) {
  let encoder = new TextEncoder();
  content = encoder.encode(content);

  let action = await ibbInstance.getNodeById(handle);
  if (action.error.type) {
    throw new Error('Error getting node by id: ' + action.error.type);
  }

  let oldnode = action.node;
  let name = oldnode.name;

  Module.createFile(name, content);

  // Send a message to user before closing the tab during file upload
  window.onbeforeunload = () => 'Files are being uploaded.';

  let uploadAction = await ibbInstance.uploadWithCustomData(name, oldnode.parentHandle, 'edit');
  if (uploadAction.error && uploadAction.error.type) {
    window.onbeforeunload = null;
    return Promise.reject('Error uploading file: ' + uploadAction.error.type);
  }

  window.onbeforeunload = null;

  const newHandle = uploadAction.node.handle;

  // Permite al caller sincronizar store/URL con el nuevo handle ANTES de
  // borrar el nodo antiguo. Sin esto, el listener del SDK que dispara el
  // delete provoca un fetchData en Cloud.vue y puede desmontar el editor
  // mientras el hash de la URL sigue apuntando al nodo ya eliminado.
  // Mismo patrón que putIdBinary (para Sheets/Docs).
  if (typeof onNewHandle === 'function') {
    try { await onNewHandle(newHandle); } catch (_) { /* noop */ }
  }

  let delAction = await ibbInstance.deleteNode(oldnode.handle);
  if (delAction && delAction.error && delAction.error.type) {
    return Promise.reject('Error deleting old file: ' + delAction.error.type);
  }

  return newHandle;
}

export async function downloadRecoveryKey () {
    let action = await ibb.getRecoveryKey();
    if (action.error.type) {
      throw new Error('Error getting recovery key: ' + action.error.type);
    }
    
    let encoder = new TextEncoder();
    let content = encoder.encode(action.text);
    let millis = new Date().getTime();
    let fileId = 'recovery' + millis;
    Module.createFile(fileId, content);
    Module.downloadFileWithName(fileId, 'IberboxRecoveryKey.txt');
}

export async function getRecoveryKey () {
  let action = await ibb.getRecoveryKey();
  if (action.error.type) {
    throw new Error('Error getting recovery key: ' + action.error.type);
  }
  
  return action.text;
}

export async function getSecretRecoveryKey(handle) {
  let action = await ibb.getSecretRecoveryKey(handle);
  if (action.error.type) {
    throw new Error('Error getting secret recovery key: ' + action.error.type);
  }
  
  return action.text;
}

export async function getInvoicing () {
    let action = await ibb.getInvoicingInfo();
    if (action.error.type) {
      return null;
    }
    
    return action.invoicingInfo;
}

export async function setInvoicingAddress (companyName, companyAddress, companyAddress2, companyNIF) 
{
    let action = await ibb.setInvoicingAddress(companyName, companyAddress, companyAddress2, companyNIF);
    if (action.error.type) {
      throw new Error('Error setting invoicing address: ' + action.error.type);
    }
}

export async function downloadId (handle, ibbInstance = ibb) {
    let action = await ibbInstance.getNodeById(handle);
    if (action.error.type) {
      throw new Error('Error getting node: ' + action.error.type);
    }
    
    let node = action.node;
    let fileid = node.handle + '/' + node.name;
    if (Module.isFileAvailable(fileid)) {
        Module.downloadFileWithName(fileid, node.name);
        //store.commit('addDownload', node)
        return;
    }

    let name;
    let file;
    if (node.type == Module.NodeType.FILE.value) {
      file = fileid;
      name = node.name;
      if (node.parentHandle !== '') {
        let nodeParent = await ibbInstance.getNodeById(node.parentHandle);
        while (nodeParent.node.parentHandle !== '') {
          nodeParent = await ibbInstance.getNodeById(nodeParent.node.parentHandle);
        }
        if (nodeParent.node.type === Module.NodeType.SECRET_ROOT.value) {
          action = await ibbInstance.downloadWithCustomData(node.handle, file, 'secret');
        } else {
          action = await ibbInstance.download(node.handle, file);
        }
      } else {
        if (node.type === Module.NodeType.SECRET_ROOT.value) {
          action = await ibbInstance.downloadWithCustomData(node.handle, file, 'secret');
        } else {
          action = await ibbInstance.download(node.handle, file);
        }
      }
    }
    else {
      file = fileid;
      if (node.parentHandle !== '') {
        let nodeParent = await ibbInstance.getNodeById(node.parentHandle);
        while (nodeParent.node.parentHandle !== '') {
          nodeParent = await ibbInstance.getNodeById(nodeParent.node.parentHandle);
        }
        if (nodeParent.node.type === Module.NodeType.SECRET_ROOT.value) {
          action = await ibbInstance.downloadZipWithCustomData(node.handle, file, 'secret');
        } else {
          action = await ibbInstance.downloadZip(node.handle, file);
        }
      } else {
        if (node.type === Module.NodeType.SECRET_ROOT.value) {
          action = await ibbInstance.downloadZipWithCustomData(node.handle, file, 'secret');
        } else {
          action = await ibbInstance.downloadZip(node.handle, file);
        }
      } 
      file = file + '.zip';  
      name = node.name + '.zip';
    }

    if (action.error.type) {
      throw new Error('Error downloading node: ' + action.error.type);
    }  

    Module.downloadFileWithName(file, name);
    //store.commit('addDownload', node)
}

export async function download (format, ...files) {


for (let userfile of files) {
  let path = decodeURIComponent(userfile);
  let action = await ibb.getNodeByPath(path);
  if (action.error.type) {
    throw new Error('Error getting node by path: ' + action.error.type);
  }

  let node = action.node;
  let fileid = node.handle + '/' + node.name;
  if (Module.isFileAvailable(fileid)) {
      Module.downloadFileWithName(fileid, node.name);
      //store.commit('addDownload', node)
      return;
  }

  let name;
  let file;
  if (node.type == Module.NodeType.FILE.value) {
    file = fileid;
    name = node.name;
    action = await ibb.download(node.handle, file);
  }
  else {
    file = fileid;
    action = await ibb.downloadZip(node.handle, file);  
    file = file + '.zip';  
    name = node.name + '.zip';
  }

  if (action.error.type) {
    throw new Error('Error downloading node: ' + action.error.type);
  }  

  Module.downloadFileWithName(file, name);
  //store.commit('addDownload', node)
}

  /*let url = `${baseURL}/api/raw`

  if (files.length === 1) {
    url += removePrefix(files[0]) + '?'
  } else {
    let arg = ''

    for (let file of files) {
      arg += removePrefix(file) + ','
    }

    arg = arg.substring(0, arg.length - 1)
    arg = encodeURIComponent(arg)
    url += `/?files=${arg}&`
  }

  if (format !== null) {
    url += `algo=${format}&`
  }

  url += `auth=${store.state.jwt}`
  window.open(url)*/
}


export async function createFile(parentHandle, name, ibbInstance = ibb) {
    Module.createFile(name, new Uint8Array([10]));
    let action = await ibbInstance.uploadWithCustomData(name, parentHandle, 'edit');
    if (action.error.type) {
      throw new Error('Error creating file: ' + action.error.type);
    }
    return action.node.handle;
}

/**
 * Crea un archivo en la nube con contenido binario arbitrario (Uint8Array).
 * Se usa para crear hojas de cálculo y documentos vacíos (.xlsx, .docx).
 */
export async function createFileWithContent(parentHandle, name, bytes, ibbInstance = ibb) {
    if (!(bytes instanceof Uint8Array)) {
      bytes = new Uint8Array(bytes);
    }
    Module.createFile(name, bytes);
    let action = await ibbInstance.uploadWithCustomData(name, parentHandle, 'edit');
    if (action.error.type) {
      throw new Error('Error creating file: ' + action.error.type);
    }
    return action.node.handle;
}

/**
 * Descarga un archivo de la nube y devuelve sus bytes (ArrayBuffer).
 * Usado por los editores Univer para cargar .xlsx / .docx.
 *
 * Siguiendo el mismo patrón que downloadId (busca ancestro SECRET_ROOT para
 * decidir si usa `download` o `downloadWithCustomData('secret')`).
 */
export async function getFileBytes(handle, ibbInstance = ibb) {
    let action = await ibbInstance.getNodeById(handle);
    if (action.error.type) {
      throw new Error('Error getting node: ' + action.error.type);
    }
    const node = action.node;
    const fileid = node.handle + '/' + node.name;

    if (!Module.getObjectURL(fileid)) {
      let dl;
      if (node.parentHandle && node.parentHandle !== '') {
        let nodeParent = await ibbInstance.getNodeById(node.parentHandle);
        // Camina hasta la raíz
        while (nodeParent.node && nodeParent.node.parentHandle && nodeParent.node.parentHandle !== '') {
          nodeParent = await ibbInstance.getNodeById(nodeParent.node.parentHandle);
        }
        const isSecret = nodeParent.node && nodeParent.node.type === Module.NodeType.SECRET_ROOT.value;
        dl = isSecret
          ? await ibbInstance.downloadWithCustomData(node.handle, fileid, 'secret')
          : await ibbInstance.download(node.handle, fileid);
      } else {
        // Archivo a nivel raíz (raro): descarga normal
        dl = await ibbInstance.download(node.handle, fileid);
      }
      if (dl && dl.error && dl.error.type) {
        throw new Error('Error downloading file: ' + dl.error.type);
      }
    }

    const url = Module.getObjectURL(fileid);
    if (!url) {
      throw new Error('No se pudo obtener la URL del archivo descargado');
    }
    // OJO: en este módulo `fetch` está SOMBREADO por el `export function fetch`
    // de más arriba (el wrapper de getNodeByPath). Hay que llamar explícitamente
    // a `window.fetch` para usar el fetch nativo del navegador.
    const res = await window.fetch(url);
    return await res.arrayBuffer();
}

/**
 * Guarda contenido BINARIO (Uint8Array) como nueva versión del archivo.
 * Análogo a putId pero sin pasar por TextEncoder (preservaría el binario intacto).
 */
export async function putIdBinary(handle, bytes, ibbInstance = ibb, onNewHandle) {
    if (!(bytes instanceof Uint8Array)) {
      bytes = new Uint8Array(bytes);
    }

    let action = await ibbInstance.getNodeById(handle);
    if (action.error.type) {
      throw new Error('Error getting node by id: ' + action.error.type);
    }
    const oldnode = action.node;
    const name = oldnode.name;

    Module.createFile(name, bytes);

    window.onbeforeunload = () => 'Files are being uploaded.';
    const uploadAction = await ibbInstance.uploadWithCustomData(name, oldnode.parentHandle, 'edit');
    window.onbeforeunload = null;
    if (uploadAction.error.type) {
      return Promise.reject('Error uploading file: ' + uploadAction.error.type);
    }

    const newHandle = uploadAction.node.handle;

    // Permite al caller actualizar estado/URL ANTES de que borremos el nodo
    // antiguo. El SDK dispara un evento al borrar que recarga el listado;
    // si el hash en la URL aún apunta al nodo borrado, el fetch falla y el
    // caller puede ser desmontado. Dando esta oportunidad al caller, puede
    // sincronizar referencias (store/URL) al newHandle antes del borrado.
    if (typeof onNewHandle === 'function') {
      try { await onNewHandle(newHandle); } catch (_) { /* noop */ }
    }

    const delAction = await ibbInstance.deleteNode(oldnode.handle);
    if (delAction && delAction.error && delAction.error.type) {
      return Promise.reject('Error deleting old file: ' + delAction.error.type);
    }

    return newHandle;
}

export async function createFolder(parentHandle, name, ibbInstance = ibb) {
    let action = await ibbInstance.createFolder(parentHandle, name);
    if (action.error.type) {
      return Promise.reject('Error creating folder ' + action.error.type);  
    }
    return Promise.resolve('200 OK');
}

export async function createInbox(name, description) {
    let action = await ibb.createInbox(name, description);
    if (action.error.type) {
      return Promise.reject('Error creating inbox ' + action.error.type);  
    }
    return Promise.resolve('200 OK');
}

export async function createResellerCoupon(username) {
  let action = await ibb.createResellerCoupon(username);
  if (action.error.type) {
    return Promise.reject('Error creating coupon ' + action.error.type);  
  }
  return Promise.resolve('200 OK');
}

export async function createSecret(name, password) {
  let action = await ibb.createSecret(name, password);
  if (action.error.type) {
    throw new Error('Error creating secret: ' + action.error.type);
  }
  return action.node.handle;
}

export async function updateSecret(handle, name, password) {
  let action = await ibb.updateSecret(handle, name, password);
  if (action.error.type) {
    throw new Error('Error updatting secret: ' + action.error.type);
  }
  return Promise.resolve('200 OK');
}

export async function openSecret(name, password) {
  let action = await ibb.openSecret(name, password);
  if (action.error.type) {
    throw new Error('Error opening secret: ' + action.error.type) ;
  }
  return action.node.handle;
}

export async function getOpenSecrets() {
  let action = await ibb.getOpenSecrets();
  if (action.error.type) {
    throw new Error('Error getting open secret: ' + action.error.type);
  }
  return action.nodeList;
}

export async function closeSecret(handle) {
  let action = await ibb.closeSecret(handle);
  if (action.error.type) {
    throw new Error('Error closing secret: ' + action.error.type); 
  }
  return Promise.resolve('200 OK');
}

export async function deleteSecret(handle) {
  let action = await ibb.deleteSecret(handle);
  if (action.error.type) {
    throw new Error('Error deleting secret: ' + action.error.type);
  }
  return Promise.resolve('200 OK');
}

export async function deleteCoupon(id) {
  let action = await ibb.deleteCoupon(id);
  if (action.error.type) {
    return Promise.reject('Error deleting coupon ' + action.error.type);  
  }
  return Promise.resolve('200 OK');
}

export async function postId(parentHandle, content, previousHandle = false, onupload, ibbInstance = ibb) {
  await Module.registerFile(content);
  //store.commit('addUpload', content)

  window.onbeforeunload = () => 'Files are being uploaded.';
  let name = content.name;

  if (parentHandle !== '') {
    let nodeParent = await ibbInstance.getNodeById(parentHandle);
    while (nodeParent.node.parentHandle !== '') {
      nodeParent = await ibbInstance.getNodeById(nodeParent.node.parentHandle);
    } 
    if (nodeParent.node.type === Module.NodeType.SECRET_ROOT.value) {
      return ibbInstance.uploadWithCustomData(content.name, parentHandle, 'secret')
      .then(function(action)
      {
        if (action.error.type) {
          return;
        }

        if (previousHandle) {
          ibbInstance.deleteNode(previousHandle);
        }

        let re = /(?:\.([^.]+))?$/;
        let extension = re.exec(action.node.name)[1] || '';
        extension = extension.toLowerCase();

        if (extension == 'jpg' || extension == 'jpeg' || extension == 'png' || extension == 'bmp' || extension == 'heic' || extension == 'heif') {
          let file = Module.getFile(name);

          console.log('Image uploaded. Creating metadata. Orientation: ' + file['orientation']);
          let handle = action.node.handle;
          let url = Module.getObjectURL(name);

          let thumbnailName = '///thumbnails/' + handle;
          let previewName = '///previews/' + handle;
          Module.createMetadata(url, Module.MetadataType.META_THUMBNAIL.value, function(data) {
              console.log('Thumbnail created: ' + data.length + ' bytes');
              Module.createFile(thumbnailName, data);
              ibbInstance.uploadMetadata(thumbnailName, handle, Module.MetadataType.META_THUMBNAIL.value);
          }, file['orientation']);

          Module.createMetadata(url, Module.MetadataType.META_PREVIEW.value, function(data) {
              console.log('Preview created: ' + data.length + ' bytes');
              Module.createFile(previewName, data);
              ibbInstance.uploadMetadata(previewName, handle, Module.MetadataType.META_PREVIEW.value);
          }, file['orientation']);
        }
      })
      .finally(() => { window.onbeforeunload = null; });
    } else {
      return ibbInstance.upload(content.name, parentHandle)
      .then(async function(action)
      {
        if (action.error.type) {
          return;
        }

        if (previousHandle) {
          await ibbInstance.deleteNode(previousHandle);
        }

        let re = /(?:\.([^.]+))?$/;
        let extension = re.exec(action.node.name)[1] || '';
        extension = extension.toLowerCase();

        if (extension == 'jpg' || extension == 'jpeg' || extension == 'png' || extension == 'bmp' || extension == 'heic' || extension == 'heif') {
          let file = Module.getFile(name);

          console.log('Image uploaded. Creating metadata. Orientation: ' + file['orientation']);
          let handle = action.node.handle;
          let url = Module.getObjectURL(name);

          let thumbnailName = '///thumbnails/' + handle;
          let previewName = '///previews/' + handle;
          Module.createMetadata(url, Module.MetadataType.META_THUMBNAIL.value, function(data) {
              console.log('Thumbnail created: ' + data.length + ' bytes');
              Module.createFile(thumbnailName, data);
              ibbInstance.uploadMetadata(thumbnailName, handle, Module.MetadataType.META_THUMBNAIL.value);
          }, file['orientation']);

          Module.createMetadata(url, Module.MetadataType.META_PREVIEW.value, function(data) {
              console.log('Preview created: ' + data.length + ' bytes');
              Module.createFile(previewName, data);
              ibbInstance.uploadMetadata(previewName, handle, Module.MetadataType.META_PREVIEW.value);
          }, file['orientation']);
        }
      })
      .finally(() => { window.onbeforeunload = null; });
    }
  } else {
    if (nodeParent.node.type === Module.NodeType.SECRET_ROOT.value) {
      return ibbInstance.uploadWithCustomData(content.name, parentHandle, 'secret')
      .then(function(action)
      {
        if (action.error.type) {
          return;
        }

        if (previousHandle) {
          ibbInstance.deleteNode(previousHandle);
        }

        let re = /(?:\.([^.]+))?$/;
        let extension = re.exec(action.node.name)[1] || '';
        extension = extension.toLowerCase();

        if (extension == 'jpg' || extension == 'jpeg' || extension == 'png' || extension == 'bmp' || extension == 'heic' || extension == 'heif') {
          let file = Module.getFile(name);

          console.log('Image uploaded. Creating metadata. Orientation: ' + file['orientation']);
          let handle = action.node.handle;
          let url = Module.getObjectURL(name);

          let thumbnailName = '///thumbnails/' + handle;
          let previewName = '///previews/' + handle;
          Module.createMetadata(url, Module.MetadataType.META_THUMBNAIL.value, function(data) {
              console.log('Thumbnail created: ' + data.length + ' bytes');
              Module.createFile(thumbnailName, data);
              ibbInstance.uploadMetadata(thumbnailName, handle, Module.MetadataType.META_THUMBNAIL.value);
          }, file['orientation']);

          Module.createMetadata(url, Module.MetadataType.META_PREVIEW.value, function(data) {
              console.log('Preview created: ' + data.length + ' bytes');
              Module.createFile(previewName, data);
              ibbInstance.uploadMetadata(previewName, handle, Module.MetadataType.META_PREVIEW.value);
          }, file['orientation']);
        }
      })
      .finally(() => { window.onbeforeunload = null; });
    } else {
      return ibbInstance.upload(content.name, parentHandle)
      .then(function(action)
      {
        if (action.error.type) {
          return;
        }

        if (previousHandle) {
          ibbInstance.deleteNode(previousHandle);
        }

        let re = /(?:\.([^.]+))?$/;
        let extension = re.exec(action.node.name)[1] || '';
        extension = extension.toLowerCase();

        if (extension == 'jpg' || extension == 'jpeg' || extension == 'png' || extension == 'bmp' || extension == 'heic' || extension == 'heif') {
          let file = Module.getFile(name);

          console.log('Image uploaded. Creating metadata. Orientation: ' + file['orientation']);
          let handle = action.node.handle;
          let url = Module.getObjectURL(name);

          let thumbnailName = '///thumbnails/' + handle;
          let previewName = '///previews/' + handle;
          Module.createMetadata(url, Module.MetadataType.META_THUMBNAIL.value, function(data) {
              console.log('Thumbnail created: ' + data.length + ' bytes');
              Module.createFile(thumbnailName, data);
              ibbInstance.uploadMetadata(thumbnailName, handle, Module.MetadataType.META_THUMBNAIL.value);
          }, file['orientation']);

          Module.createMetadata(url, Module.MetadataType.META_PREVIEW.value, function(data) {
              console.log('Preview created: ' + data.length + ' bytes');
              Module.createFile(previewName, data);
              ibbInstance.uploadMetadata(previewName, handle, Module.MetadataType.META_PREVIEW.value);
          }, file['orientation']);
        }
      })
      .finally(() => { window.onbeforeunload = null; });
    }
  }
}

export async function post (url, content = '') {
  url = removePrefix(url);
  console.log('post: ' + url + ' ' + content);

  let path = decodeURIComponent(url);
  
  let previousNode;
  let action = await ibb.getNodeByPath(path);
  if (!action.error.type) {
    previousNode = action.node;
  }

  let index = path.lastIndexOf('/', path.length - 2);
  let basepath = path.substring(0, index + 1);
  
  action = await ibb.getNodeByPath(basepath);
  if (action.error.type) {
    return Promise.reject('Error getting base path: ' + basepath + '('  + action.error.type + ')');
  }

  if (content)
  {
    await Module.registerFile(content);
    
    // Send a message to user before closing the tab during file upload
    window.onbeforeunload = () => 'Files are being uploaded.';

    let name = content.name;

    return ibb.upload(content.name, action.node.handle)
              .then(function(action)
              {
                if (previousNode) {
                  ibb.deleteNode(previousNode.handle);
                }

                let re = /(?:\.([^.]+))?$/;
                let extension = re.exec(action.node.name)[1] || '';
                extension = extension.toLowerCase();

                if (extension == 'jpg' || extension == 'jpeg' || extension == 'png' || extension == 'bmp' || extension == 'heic' || extension == 'heif') {
                  let file = Module.getFile(name);
                  console.log('Image uploaded. Creating metadata. Orientation: ' + file['orientation']);
                  let handle = action.node.handle;
                  let url = Module.getObjectURL(name);

                  let thumbnailName = '///thumbnails/' + handle;
                  let previewName = '///previews/' + handle;
                  Module.createMetadata(url, Module.MetadataType.META_THUMBNAIL.value, function(data) {
                      console.log('Thumbnail created: ' + data.length + ' bytes');
                      Module.createFile(thumbnailName, data);
                      ibb.uploadMetadata(thumbnailName, handle, Module.MetadataType.META_THUMBNAIL.value);
                  }, file['orientation']);

                  Module.createMetadata(url, Module.MetadataType.META_PREVIEW.value, function(data) {
                      console.log('Preview created: ' + data.length + ' bytes');
                      Module.createFile(previewName, data);
                      ibb.uploadMetadata(previewName, handle, Module.MetadataType.META_PREVIEW.value);
                  }, file['orientation']);
                }
              })
              .finally(() => { window.onbeforeunload = null; });
  }

  if (path[path.length - 1] == '/') {
    let name = path.substring(index + 1, path.length - 1);
    action = await ibb.createFolder(action.node.handle, name);
    if (action.error.type) {
      return Promise.reject('Error creating folder');  
    }
  }
  else {
    let name = path.substring(index + 1);
    Module.createFile(name, new Uint8Array([10]));
    action = await ibb.upload(name, action.node.handle);
    if (action.error.type) {
      return Promise.reject('Error creating file');  
    }
  }

  return Promise.resolve('200 OK');
}

export async function copyId (items, ibbInstance = ibb) {
  let promises = [];

  for (let item of items) {
      let fromhandle = item.from; 
      let tohandle = item.to;

      console.log('copy from: ' + fromhandle);
      console.log('to: ' + tohandle);

      let action = await ibbInstance.copyNode(fromhandle, tohandle);
      if (action.error.type) {
        promises.push(Promise.reject('Error copying node'));
        continue;
      }

      promises.push(Promise.resolve('200 OK'));
  }

  return Promise.all(promises);
}

export async function renameId (items, ibbInstance = ibb) {
  let promises = [];

  for (let item of items) {
      let fromhandle = item.from;   
      let toname = item.to;

      console.log('rename from: ' + fromhandle);
      console.log('to: ' + toname);

      // const {node} = await ibbInstance.getNodeById(fromhandle);

      let action = await ibbInstance.renameNode(fromhandle, toname);
      if (action.error.type) {
        promises.push(Promise.reject('Error renaming node'));
        continue;
      }
      // // Obtener logNodeHandle desde el store.
      // // Guardar el logNodeHandle en el store cada vez que se navega a una ruta raíz
      // try {
      //   const logger = await ActionLogger.fromLogNode(logNodeHandle);
      // // El action, en este caso 'RNM', debería consensuarse para establecer
      // // una "enumeración" de la que obtener las acciones que queramos loguear
      //   await logger.logAction('RNM', node.handle, node.name);
      // } catch (e) {
      //   console.error(e);
      // }
      promises.push(Promise.resolve('200 OK'));
  }

  return Promise.all(promises);
}

export async function setInboxInfo (handle, name, description) {
    let action = await ibb.setInboxInfo(handle, name, description);
    if (action.error.type) {
      return Promise.reject('Error changing inbox info ' + action.error.type);  
    }
    return Promise.resolve('200 OK');
}

export async function moveId (items, ibbInstance = ibb) {
  let promises = [];

  for (let item of items) {
      let fromhandle = item.from;  
      let tohandle = item.to;

      console.log('move from: ' + fromhandle);
      console.log('to: ' + tohandle);

      let action = await ibbInstance.moveNode(fromhandle, tohandle);
      if (action.error.type) {
        promises.push(Promise.reject('Error moving node'));
        continue;
      }

      promises.push(Promise.resolve('200 OK'));
  }

  return Promise.all(promises);
}

async function moveCopy (items, copy = false) {
  let promises = [];

  for (let item of items) {
    let fromurl = removePrefix(item.from);  
    let frompath = decodeURIComponent(fromurl);
    if (frompath.charAt(frompath.length - 1) == '/')
    {
      frompath = frompath.substring(0, frompath.length - 1);
    }  

    let fromindex = frompath.lastIndexOf('/');
    let frombasepath = frompath.substring(0, fromindex + 1);
    let fromname = frompath.substring(fromindex + 1);

    let tourl = removePrefix(item.to);
    let topath = decodeURIComponent(tourl);
    let toindex = topath.lastIndexOf('/');
    let tobasepath = topath.substring(0, toindex + 1);
    let toname = topath.substring(toindex + 1);
  
    console.log('Copy? ' + copy);
    console.log('frompath: ' + frompath + ' frombasepath:  ' + frombasepath + ' fromname:' + fromname);
    console.log('topath: ' + topath + ' tobasepath:  ' + tobasepath + ' toname:' + toname);

    let action = await ibb.getNodeByPath(frompath);
    if (action.error.type) {
      promises.push(Promise.reject('Error getting from path: ' + frompath + '('  + action.error.type + ')'));
      continue;
    }
    let fromnode = action.node;

    if (copy) {
      if (fromname == toname) {
        action = await ibb.getNodeByPath(tobasepath);
        if (action.error.type) {
          promises.push(Promise.reject('Error getting destination path: ' + tobasepath + '('  + action.error.type + ')'));
          continue;
        }

        action = await ibb.copyNode(fromnode.handle, action.node.handle);
        if (action.error.type) {
          promises.push(Promise.reject('Error copying node'));
          continue;
        }

        promises.push(Promise.resolve('200 OK'));
      }
      else {
        promises.push(Promise.reject('Operation not supported')); 
      }
    }
    else {
      if (frombasepath == tobasepath) {
        action = await ibb.renameNode(fromnode.handle, toname);
        if (action.error.type) {
          promises.push(Promise.reject('Error renaming node'));
          continue;
        }
        promises.push(Promise.resolve('200 OK'));
      }
      else if (fromname == toname) {
        action = await ibb.getNodeByPath(tobasepath);
        if (action.error.type) {
          promises.push(Promise.reject('Error getting destination path: ' + tobasepath + '('  + action.error.type + ')'));
          continue;
        }

        action = await ibb.moveNode(fromnode.handle, action.node.handle);
        if (action.error.type) {
          promises.push(Promise.reject('Error moving node'));
          continue;
        }

        promises.push(Promise.resolve('200 OK'));
      }
      else {
        promises.push(Promise.reject('Operation not supported')); 
      }
    }

    //const from = removePrefix(item.from)
    //const to = encodeURIComponent(removePrefix(item.to))
    //const url = `${from}?action=${copy ? 'copy' : 'rename'}&destination=${to}`
    //promises.push(resourceAction(url, 'PATCH'))
  }

  return Promise.all(promises);
}

export function move (items) {
  return moveCopy(items);
}

export function copy (items) {
  return moveCopy(items, true);
}

export async function checksum (url, algo) {
  const data = await resourceAction(`${url}?checksum=${algo}`, 'GET');
  return (await data.json()).checksums[algo];
}
